export const constantMotives = [
	{ value: 0, label: 'MEDIDAS DE CONTENÇÃO' },
	{ value: 1, label: 'RISCO GRAVE E IMINENTE' },
	{ value: 2, label: 'ATENDIMENTO LEGAL/REGULATÓRIO' },
	{ value: 3, label: 'MANUTENÇÃO DA PRODUÇÃO' },
	{ value: 4, label: 'ATIVIDADES OPERACIONAIS NÃO CRÍTICAS' },
];
